import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: '',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="relative z-10 text-center px-4 max-w-3xl mx-auto text-white">
          <h1 className="text-5xl md:text-6xl font-serif mb-4">
            {t.about.hero_title}
          </h1>
          <p className="text-lg md:text-xl">{t.about.hero_subtitle}</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-serif text-gray-900 mb-6 text-center">
            {t.about.section1_title}
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed text-center">
            {t.about.section1_content}
          </p>
        </div>
      </section>

      {/* Image Divider */}
      <section className="relative h-[40vh] overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'url(/images/about-us.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
      </section>

      {/* Vision Section */}
      <section className="py-20 px-4 bg-stone-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-serif text-gray-900 mb-6 text-center">
            {t.about.section2_title}
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed text-center">
            {t.about.section2_content}
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-serif text-gray-900 mb-12 text-center">
            {t.about.section3_title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {t.about.values.map((value, index) => (
              <div key={index} className="p-6 border border-gray-200 hover:border-gray-900 transition-colors">
                <p className="text-gray-700 leading-relaxed">{value}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team or Additional Section */}
<section className="py-20 px-4 bg-slate-50">
  <div className="max-w-7xl mx-auto text-center">
    <h2 className="text-4xl font-serif text-gray-900 mb-6">
      {t.team.title}
    </h2>
    <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto mb-12">
      {t.team.subtitle}
    </p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-blue-100 flex items-center justify-center">
          <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h3 className="text-xl font-serif text-gray-900 mb-2">{t.team.expert_title}</h3>
        <p className="text-gray-600 text-sm">{t.team.expert_desc}</p>
      </div>
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-blue-100 flex items-center justify-center">
          <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-xl font-serif text-gray-900 mb-2">{t.team.quality_title}</h3>
        <p className="text-gray-600 text-sm">{t.team.quality_desc}</p>
      </div>
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-blue-100 flex items-center justify-center">
          <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </div>
        <h3 className="text-xl font-serif text-gray-900 mb-2">{t.team.customer_title}</h3>
        <p className="text-gray-600 text-sm">{t.team.customer_desc}</p>
      </div>
    </div>
  </div>
</section>
    </div>
  );
};

export default About;